import React from 'react';
import MyMessages from '../../components/MyMessages';
import styled from 'styled-components';

const MessagesPageContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const PageTitle = styled.h1`
  font-size: 18px;
  margin-bottom: 20px;
  color: #333;
  border-bottom: 2px solid #ef4444;
  padding-bottom: 10px;
`;

const Messages: React.FC = () => {
  return (
    <MessagesPageContainer>
      <PageTitle>내 쪽지함</PageTitle>
      <MyMessages />
    </MessagesPageContainer>
  );
};

export default Messages; 